import { ArrowRight } from "lucide-react";
import type { SimpleCardConfig } from "./demoHubConfig";

type DemoResourcesSectionProps = {
  resources: SimpleCardConfig[];
  onPlaceholderClick: (title: string) => void;
};

export function DemoResourcesSection({ resources, onPlaceholderClick }: DemoResourcesSectionProps) {
  return (
    <section className="border-t border-slate-200 bg-white py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-6 lg:grid-cols-[0.42fr_0.58fr] lg:items-end">
          <div>
            <h2 className="font-space-grotesk text-3xl font-bold leading-tight text-slate-950 sm:text-4xl">
              Sales resources
            </h2>
            <p className="mt-4 max-w-xl text-base leading-7 text-slate-600">
              Use these assets before, during, or after a sales conversation.
            </p>
          </div>
          <p className="max-w-2xl text-sm leading-6 text-slate-500 lg:justify-self-end">
            For v1, these assets are placeholders so the page can be shared now without broken
            downloads or unavailable embeds.
          </p>
        </div>

        <div className="mt-10 grid gap-px border border-slate-200 bg-slate-200 md:grid-cols-2 lg:grid-cols-4">
          {resources.map((resource) => {
            const Icon = resource.icon;
            return (
              <button
                key={resource.title}
                type="button"
                className="group flex min-h-[260px] flex-col bg-white p-6 text-left transition-colors hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400"
                onClick={() => onPlaceholderClick(resource.title)}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex h-11 w-11 items-center justify-center border border-slate-200 bg-slate-50 text-slate-800">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </div>
                  <span className="rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-semibold text-slate-600">
                    {resource.status}
                  </span>
                </div>
                <h3 className="mt-6 font-space-grotesk text-xl font-semibold leading-tight text-slate-950">
                  {resource.title}
                </h3>
                <p className="mt-4 flex-1 text-sm leading-6 text-slate-600">
                  {resource.description}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-slate-500">
                  {resource.ctaLabel}
                  <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
